import { cn } from "@/lib/utils";
import { Star, Shield, Award, TrendingUp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

function getReputationTier(score: number): { label: string; color: string; icon: React.FC<{ className?: string }> } {
	if (score >= 4.8) return { label: "Elite Trader", color: "text-amber-500", icon: Award };
	if (score >= 4.5) return { label: "Trusted", color: "text-emerald-500", icon: Shield };
	if (score >= 4.0) return { label: "Reliable", color: "text-blue-500", icon: TrendingUp };
	return { label: "New Trader", color: "text-muted-foreground", icon: Star };
}

export function ReputationBadge({
	reputation,
	totalSwaps,
	size = "sm",
}: {
	reputation: number;
	totalSwaps: number;
	size?: "sm" | "md";
}) {
	const tier = getReputationTier(reputation);
	const Icon = tier.icon;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<div className={cn("flex items-center gap-1", size === "md" ? "gap-1.5" : "gap-1")}>
					<Icon className={cn("h-3.5 w-3.5", tier.color, size === "md" && "h-4 w-4")} />
					<span className={cn("font-semibold tabular-nums", tier.color, size === "md" ? "text-sm" : "text-xs")}>
						{reputation.toFixed(1)}
					</span>
					<div className="flex">
						{[1, 2, 3, 4, 5].map((star) => (
							<Star
								key={star}
								className={cn(
									"h-2.5 w-2.5",
									size === "md" && "h-3 w-3",
									star <= Math.round(reputation)
										? "fill-amber-400 text-amber-400"
										: "text-muted-foreground/30"
								)}
							/>
						))}
					</div>
				</div>
			</TooltipTrigger>
			<TooltipContent>
				<p className="font-medium">{tier.label}</p>
				<p className="text-xs text-muted-foreground">{totalSwaps} total swaps</p>
			</TooltipContent>
		</Tooltip>
	);
}
